// dependencies
import React, { useState } from "react";
import PropTypes from "prop-types";

// components
import Cell from "./Cell";

// utils
import get from "Utils/get";

// style
import css from "../Table.styl";

// actions
// import { ChangePage } from 'actions/navigation.actions';

const Row = (props) => {
	const { row, columns, colWidths, subheaders, subheaderColWidths, cellClassName, currentScreenWidth, hoverRowURL } =
		props;
	const keys = Object.keys(subheaders);

	const [hovering, setHovering] = useState(false);

	const alignColumns = () =>
		columns.map((column) => {
			// get the field name
			const field = get(["id"], column);

			// hide column value
			const mobileViewHideColumn = get(["mobileViewHideColumn"], column, false);

			// get the getter, if it exists
			const getter = get(["getter"], column, null);

			// get the value
			const value = getter ? getter(row) : get([field], row, "");
			// render
			return (
				<Cell
					className={`${cellClassName || ""} ${
						mobileViewHideColumn > currentScreenWidth ? css.hiddenColumn : ""
					}`}
					key={field}
				>
					{value}
				</Cell>
			);
		});
	const alignSubheaders = () =>
		keys.map((key) => {
			const subheaderGroup = subheaders[key];
			return subheaderGroup.map((subheader) => {
				const field = get(["id"], subheader);
				const getter = get(["getter"], subheader, null);
				const value = getter ? getter(row) : get([field], row, "");
				const mobileViewHideColumn = get(["mobileViewHideColumn"], subheader, false);
				return (
					<Cell
						className={`${css.subheaderCell} ${
							mobileViewHideColumn > currentScreenWidth ? css.hiddenColumn : ""
						}`}
						key={field}
					>
						{value}
					</Cell>
				);
			});
		});

	return (
		<div
			testid="tableRow"
			className={`${css.row} ${hoverRowURL && hovering ? css.hoverRow : null}`}
			onMouseEnter={() => setHovering(true)}
			onMouseLeave={() => setHovering(false)}
			onClick={() => {}}
		>
			<div
				className={css.rowContent}
				style={keys.length ? { gridTemplateColumns: subheaderColWidths } : { gridTemplateColumns: colWidths }}
			>
				{keys.length ? alignSubheaders() : alignColumns()}
			</div>
		</div>
	);
};

Row.propTypes = {
	cellClassName: PropTypes.string,
	subheaders: PropTypes.object,
	subheaderColWidths: PropTypes.string,
	columns: PropTypes.array.isRequired,
	row: PropTypes.object.isRequired,
	colWidths: PropTypes.string.isRequired,
	currentScreenWidth: PropTypes.number.isRequired,
	hoverRowURL: PropTypes.string,
};

Row.defaultProps = {
	subheaders: {},
	subheaderColWidths: "",
	cellClassName: null,
	hoverRowURL: "",
};

export default Row;
